import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';

/**
 * ตรวจสอบ Package และ Favorites Limit
 * @param {string} userId - User ID
 * @returns {Promise<object>} Package info และ favorites limit
 */
export const checkFavoritesPackage = async (userId) => {
  try {
    const userRef = doc(db, 'users', userId);
    const userSnap = await getDoc(userRef);
    
    if (!userSnap.exists()) {
      return { 
        hasPackage: false, 
        favoritesLimit: 5, // Default free limit
        favoritesUsed: 0,
        favoritesRemaining: 5,
        packageType: 'free'
      };
    }

    const userData = userSnap.data();
    const userRole = userData?.role || 'customer';
    
    // ตรวจสอบ user package
    const userPackageType = userData?.plan || userData?.tier || userData?.subscription || 'free';
    
    // Get favorites count from localStorage
    const favorites = JSON.parse(localStorage.getItem(`favorites_${userId}`) || '[]');
    const favoritesUsed = favorites.length;
    
    // Define favorites limit based on package (เหมือนแอพหาคู่)
    let favoritesLimit = 5; // Free: 5 favorites
    
    if (userPackageType === 'basic') {
      favoritesLimit = 20; // Basic: 20 favorites
    } else if (userPackageType === 'premium') {
      favoritesLimit = 50; // Premium: 50 favorites
    } else if (userPackageType === 'silver') {
      favoritesLimit = 30; // Silver: 30 favorites
    } else if (userPackageType === 'gold') {
      favoritesLimit = 100; // Gold: 100 favorites
    } else if (userPackageType === 'platinum' || userPackageType === 'vip' || userPackageType === 'enterprise') {
      favoritesLimit = -1; // Unlimited
    }
    
    const favoritesRemaining = favoritesLimit === -1 ? -1 : Math.max(0, favoritesLimit - favoritesUsed);
    
    return {
      hasPackage: userPackageType !== 'free',
      packageType: userPackageType,
      favoritesLimit,
      favoritesUsed,
      favoritesRemaining,
      canAddMore: favoritesLimit === -1 || favoritesUsed < favoritesLimit
    };
  } catch (error) {
    console.error('Error checking favorites package:', error);
    return { 
      hasPackage: false, 
      favoritesLimit: 5,
      favoritesUsed: 0,
      favoritesRemaining: 5,
      packageType: 'free',
      canAddMore: true,
      error: error.message 
    };
  }
};

/**
 * ตรวจสอบว่าสามารถเพิ่ม favorites ได้หรือไม่
 * @param {string} userId - User ID
 * @returns {Promise<boolean>} true ถ้าสามารถเพิ่มได้
 */
export const canAddFavorite = async (userId) => {
  const packageInfo = await checkFavoritesPackage(userId);
  return packageInfo.canAddMore;
};

/**
 * นับจำนวน favorites ปัจจุบัน
 * @param {string} userId - User ID
 * @returns {number} จำนวน favorites
 */
export const getFavoritesCount = (userId) => {
  if (!userId) return 0;
  try {
    const favorites = JSON.parse(localStorage.getItem(`favorites_${userId}`) || '[]');
    return favorites.length;
  } catch (error) {
    console.error('Error getting favorites count:', error);
    return 0;
  }
};

